module.exports = __webpack_public_path__ + "img/aggregated_brand_dashboard_v2.7060d253.png";